
$(document).ready(function () {
  $('.compatible_show').click(function(){
	$('.compatible_accessories-inner .product-item').show(300);
	$('.compatible_hide').show();
	$('.compatible_show').hide();
});
  $('.compatible_hide').click(function(){
	$('.compatible_accessories-inner .product-item:not(.visible_product_items)').hide(150);
	$('.compatible_show').show();
	$(this).hide();
       $('html, body').animate({
     scrollTop: $('.compatible_accessories-outer').offset().top - 70}, 300);
});
$('.accessory-widget-input').change(function(){
if($(this).is(':checked')){
  $(this).parents('.product-item').addClass('accessory-item-overlay');
 $(`.sticky-add-to-cart .accessory-widget-input[value=${$(this).val()}]`).prop( "checked", true );
 }else{
  $(`.sticky-add-to-cart .accessory-widget-input[value=${$(this).val()}]`).prop( "checked", false);
 }
  
   
  setTimeout(function(){$('.product-item').removeClass('accessory-item-overlay');},500);
});
/** variant select box change event **/
  $('.compatible_accessories_select').change(function(e){
    e.preventDefault();
    var vTitle= $('option:selected',this).text();
      var vID= $('option:selected',this).val();
   //alert(vID);
    $(this).parents('.product-item.cart').find('form input[name="id"]').val(vID);
    var Vimg=$.trim($('option:selected',this).attr('data-image'));
    var VPrice=$.trim($('option:selected',this).attr('data-price'));
      var VCPrice=$.trim($('option:selected',this).attr('data-compareP'));
    var inventory_quantity=$.trim($('option:selected',this).attr('data-inventory_quantity'));
    inventory_quantity=parseInt(inventory_quantity);
    var inventory_policy=$.trim($('option:selected',this).attr('data-inventory_policy'));
   $(this).parents('.product-item').find('.variant-title').html(vTitle);
     $(this).parents('.product-item').find('.compatible_accessories_url').attr('data-id',vID);
    $(this).parents('.product-item').find('.accessory-widget-input').val(vID);
    $(`.sticky-add-to-cart .compatible_accessories_select option[value=${$(this).val()}]`).parents('.product-item').find('.accessory-widget-input').val(vID);
    $(this).parents('.product-item').attr('data-id',vID);
  
    if(Vimg !=''){
    $(this).parents('.product-item').find('.compatible_accessories_url .items-content-inner img').attr('src',Vimg);
    }
     if(VPrice !=''){
    $(this).parents('.product-item').find('.compatible_accessories_url .pice-text').html(VPrice);
    }
     if(VCPrice !='' && VCPrice !=VPrice){
    $(this).parents('.product-item').find('.compatible_accessories_url .item-price .tw-line-through').html(VCPrice).show();
    }else{
       $(this).parents('.product-item').find('.compatible_accessories_url .item-price .tw-line-through').hide();
    }
    if(inventory_quantity <=0 && inventory_policy =='continue'){
       $(this).parents('.product-item').find('.compatible_accessories_url .compatible_accessories_preOrder').show(); 
    }else{
      $(this).parents('.product-item').find('.compatible_accessories_url .compatible_accessories_preOrder').hide(); 
    }
});
/** variant select box change event END HERE**/  
  /** product box click event **/
 $('.compatible_accessories_url').click(function(e){
   e.preventDefault();
   var vid=$(this).attr('data-id');
   var input_field= $(this).parents('.product-item').find('input').is(':checked');
   var variant_size= parseInt($(this).parents('.product-item').find('input').attr('data-variant-length'));
   var purl=  $(this).attr('href')+'?view=compatible-accessories-detail';
   $.ajax({
   url:purl,
   type:"GET",
   success:function(data){
  $('.custom-compatible-detail-drawer').addClass('active');
     $('body').addClass('open_drw_new');
     $('.custom-compatible-detail-drawer .compatible-pro-outer').html($('.compatible-pro-outer',data).html());
      $('.custom-compatible-detail-drawer .compatible-pro-outer .variant-loop li[data-id="'+vid+'"]').addClass('active');
    var selected_img = $('.custom-compatible-detail-drawer .compatible-pro-outer .variant-loop li[data-id="'+vid+'"]').attr('data-image');
     $('.compatible-drawer-images img').attr('src',selected_img);
      $('button.compatible-drawer-btn').hide();
      if(input_field== true){
   if(variant_size == 1){
      $('.accessory-back-btn').show();
    }else{
      $('button.compatible-drawer-btn.accessory-add-btn').show();
    }
  }else{
    $('button.compatible-drawer-btn.accessory-add-btn').show();
  }
   }  
     
   });
  

}); 
  /** product box click event END HERE**/
   /** product detail flyout variant box click Event **/
  $(document).on('click','.variant-loop li',function(){
    $('.variant-loop li').removeClass('active');
    $(this).addClass('active');
    var vid=$(this).attr('data-id');
    var vtitle=$(this).attr('data-title');
    var pId=$(this).attr('product_var_id');
    var checkedP=$('.product-item[product-id="'+pId+'"] .accessory-widget-input').val();
    var price= $(this).attr('data-price');
    var cprice =$(this).attr('data--compare-price');
    var v_image = $(this).attr('data-image');
    $(this).parents('.compatible-pro-outer').find('.compatible-drawer-images img').attr('src',v_image);
    $('.compatible-drawer-pice-text').html(price);
    if(cprice!=''){
       $('.compatible-drawer-price .tw-line-through').html(cprice).show();
    }else{
       $('.compatible-drawer-price .tw-line-through').html(cprice).hide();
    }
    if(vid !=checkedP){
       $('button.compatible-drawer-btn').hide();
       $('button.accessory-update-btn').show();
    }

  });
   /** product detail flyout variant box click Event END HERE**/
     /** product detail flyout button Click Event **/
$(document).on('click','.compatible-drawer-btn.accessory-add-btn , .compatible-drawer-btn.accessory-update-btn',function(e){
  e.preventDefault();
var vid=$('.variant-loop li.active').attr('data-id');
   var vtitle=$('.variant-loop li.active').attr('data-title');
  var pId=$('.variant-loop li.active').attr('product_var_id');
     var cprice =$('.variant-loop li.active').attr('data--compare-price');
   var price= $('.variant-loop li.active').attr('data-price');
   var preCheck= $('.variant-loop li.active').attr('data-pre');
   var Vimg=$.trim($('.variant-loop li.active').attr('data-image'));
   var inventory_quantity=$.trim($('.variant-loop li.active').attr('data-inventory_quantity'));
    inventory_quantity=parseInt(inventory_quantity);
    var inventory_policy=$.trim($('.variant-loop li.active').attr('data-inventory_policy'));
   $('.product-item[product-id="'+pId+'"]').attr('data-id',vid);
   $('.product-item[product-id="'+pId+'"] .compatible_accessories_url').attr('data-id',vid);
  $('.product-item[product-id="'+pId+'"] .accessory-widget-input').val(vid).prop('checked', true);
  $('.product-item[product-id="'+pId+'"] .item-price .pice-text').html(price);
  if(cprice!=''){
       $('.product-item[product-id="'+pId+'"]  .tw-line-through').html(cprice).show();
    }else{
       $('.product-item[product-id="'+pId+'"] .tw-line-through').html(cprice).hide();
    }
  if(preCheck =='pre-order'){
     $('.product-item[product-id="'+pId+'"] .compatible_accessories_preOrder').show();
  }else{
    $('.product-item[product-id="'+pId+'"] .compatible_accessories_preOrder').hide()
  }
 if(Vimg !=''){
    $('.product-item[product-id="'+pId+'"] .items-content-inner img').attr('src',Vimg);
    }
    
    if(inventory_quantity <=0 && inventory_policy =='continue'){
      $('.product-item[product-id="'+pId+'"] .compatible_accessories_preOrder').show(); 
    }else{
      $('.product-item[product-id="'+pId+'"] .compatible_accessories_preOrder').hide(); 
    }
    $('.product-item[product-id="'+pId+'"] .compatible_accessories_select option').removeAttr('selected');
console.log(vid);
   $('.product-item[product-id="'+pId+'"] .compatible_accessories_select option[value="'+vid+'"]').attr('selected', true);
   $('.product-item[product-id="'+pId+'"] .compatible_accessories_select').val(vid).change();
  
    $('.product-item [product-id="'+pId+'"] span.variant-title').html(vtitle);
  $('.custom-compatible-detail-drawer').removeClass('active');
  $('body').removeClass('open_drw_new');
});
     /** product detail flyout button click Event END HERE**/

  /** product detail flyout back  button click Event **/
  
  $(document).on('click','.compatible-drawer-btn.accessory-back-btn',function(e){
    e.preventDefault();
    $('.custom-compatible-detail-drawer').removeClass('active');
  $('body').removeClass('open_drw_new');
  });
   /** product detail flyout back  button click Event END HERE**/
});


